import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Smartphone } from '@mui/icons-material';

interface MobilePreviewProps {
    message: string;
    characterCount: number;
}

export const MobilePreview: React.FC<MobilePreviewProps> = ({ message, characterCount }) => {
    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Smartphone sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant="h6">Mobile Preview</Typography>
            </Box>

            {/* Phone mockup */}
            <Box
                sx={{
                    maxWidth: 375,
                    mx: 'auto',
                    backgroundColor: '#000',
                    borderRadius: 6,
                    p: 1,
                    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                }}
            >
                {/* Phone screen */}
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: 5,
                        overflow: 'hidden',
                        minHeight: 600,
                    }}
                >
                    {/* Status bar */}
                    <Box
                        sx={{
                            backgroundColor: '#075e54',
                            color: '#fff',
                            p: 1.5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                            WhatsApp
                        </Typography>
                        <Typography variant="caption">9:41 AM</Typography>
                    </Box>

                    {/* Message bubble */}
                    <Box sx={{ p: 2, backgroundColor: '#ece5dd', minHeight: 550 }}>
                        <Box
                            sx={{
                                backgroundColor: '#dcf8c6',
                                borderRadius: 2,
                                p: 2,
                                maxWidth: '85%',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    fontFamily: 'system-ui, -apple-system, sans-serif',
                                    fontSize: '14px',
                                    lineHeight: 1.5,
                                }}
                            >
                                {message || 'Your generated message will appear here...'}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    display: 'block',
                                    textAlign: 'right',
                                    color: 'text.secondary',
                                    mt: 0.5,
                                }}
                            >
                                {new Date().toLocaleTimeString('en-US', {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                })}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Character count */}
            <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary">
                    {characterCount} characters
                </Typography>
            </Box>
        </Paper>
    );
};
